export enum ShapeDraw {
  POINTER = 'pointer',
  PENCIL = 'pencil',
  SCRIBBLE = 'scribble',
  RECTANGLE = 'rectangle',
  CIRCLE = 'circle',
  ARROW = 'arrow',
  LINE = 'line',
  TEXT = 'text',
  START_CROP = 'start_crop',
  STOP_CROP = 'stop_crop',
}
